<template>
  <div class="hello">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索母液..."
        @on-change="searchMaterial"
        style="width: 250px; margin-right: auto"
      >
        <Button slot="append" icon="ios-search" @click="searchMaterial"></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="limit"
        @on-change="loadMaterial"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button
        v-if="
          user.superAdmin ||
          arrayIntersection(
            ['allFactoryLeader', 'factoryLeader'],
            user.simpleRole
          ).length > 0
        "
        type="primary"
        @click="openEditMaterialDrawer()"
      >新增母液</Button>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        border
        :loading="tableLoading"
        :columns="columns"
        :data="semiMaterialList"
        :height="tableHeight"
      ></Table>
    </div>
    <EditMaterialDrawer ref="EditMaterialDrawer" v-on:editSuccess="loadMaterial" />
    <EditSemiMaterialDrawer ref="EditSemiMaterialDrawer" v-on:addSuccess="loadMaterial" />
  </div>
</template>

<script>
import EditMaterialDrawer from "../RawMaterialPage/EditMaterialDrawer";
import EditSemiMaterialDrawer from "./EditSemiMaterialDrawer.vue";
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import _ from "lodash";

const seriesToText = {
  NAP: "萘系减水剂",
  PCE: "酸系减水剂",
  J: "减胶剂",
  FSA: "速凝剂",
  none: "无"
};
const tagsToText = {
  jianshui: "减水",
  baotan: "保坍",
  zaoqiang: "早强",
  "6c": "6碳"
};
export default {
  name: "Material",
  components: { EditMaterialDrawer, EditSemiMaterialDrawer },
  data() {
    return {
      page: 0,
      tableHeight: 300,
      searchText: "",
      tableLoading: false,
      filterQuery: {},
      limit: 20,
      semiMaterialList: [],
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            )
        },
        {
          title: "型号",
          key: "model",
          render: (h, params) => {
            if (
              this.user.superAdmin ||
              arrayIntersection(["allFactoryLeader"], this.user.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      color: "#42b983",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.$refs.EditMaterialDrawer.openDrawer(
                          "semi",
                          params.row
                        );
                      }
                    }
                  },
                  params.row.model
                )
              ]);
            } else {
              return h("h4", params.row.model);
            }
          }
        },
        {
          title: "配方",
          key: "recipe",
          align: "center",
          width: 100,
          render: (h, params) => {
            if (
              this.user.superAdmin ||
              arrayIntersection(["allFactoryLeader"], this.user.simpleRole)
                .length > 0
            ) {
              return h("div", [
                h(
                  "h4",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      color: "#fff",
                      backgroundColor: "#2D8CF0",
                      borderRadius: "4px",
                      border: "1px solid #2D8CF0",
                      cursor: "pointer"
                    },
                    on: {
                      click: () => {
                        this.$refs.EditSemiMaterialDrawer.openDrawer(
                          params.row,
                          "semi"
                        );
                      }
                    }
                  },
                  "配方"
                )
              ]);
            }
          }
        },
        {
          title: "名字",
          key: "name"
        },
        {
          title: "母液标签",
          key: "tags",
          align: "left",
          render: (h, params) => {
            return h("div", params.row.tagsText);
          }
        },
        {
          title: "母液类型",
          key: "series",
          align: "left",
          render: (h, params) => {
            return h("div", seriesToText[params.row.series]);
          }
        }
      ]
    };
  },
  computed: {
    ...mapState({
      tableData: state => state.material.materials,
      totalRows: state => state.material.totalCounts,
      factoryList: state => state.factory.factoryList,
      user: state => state.auth.currentUser
    })
  },
  methods: {
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      getSemiMaterialWithCost: "material/getSemiMaterialWithCostAction"
    }),
    openEditMaterialDrawer() {
      this.$refs.EditMaterialDrawer.openDrawer("semi");
    },
    async loadMaterial(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        type: "semi",
        limit: this.limit,
        skip: this.page * this.limit
      };
      if (this.searchText) {
        this.filterQuery.name = this.searchText;
      } else {
        delete this.filterQuery.name;
      }
      try {
        this.tableLoading = true;
        const semiMaterialList = await this.getMaterials(this.filterQuery);
        semiMaterialList.forEach(item => {
          let tagsText = "";
          for (let i = 0; i < item.tags.length; i++) {
            if (i === 0) {
              tagsText = tagsText + tagsToText[item.tags[i]];
            } else {
              tagsText = tagsText + "、" + tagsToText[item.tags[i]];
            }
          }
          item.tagsText = tagsText;
        });
        this.semiMaterialList = semiMaterialList;
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchMaterial: _.debounce(function() {
      this.page = 0;
      this.loadMaterial();
    }, 1000)
  },
  created() {
    this.loadMaterial();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  }
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
